import { emptySplitApiV2 } from './emptyApiV2'
import type {
	CustomAttributeComboDto,
	CustomAttributeDto,
	CustomAttributeStructureTypeEnum,
} from './mddApiSliceGenerated'
import { GetFullTreeApiArg, StructureMetadataDtoRead } from './mddApiSliceGeneratedV2'

export const mddApiV2Enhanced = emptySplitApiV2.injectEndpoints({
	endpoints: (build) => ({
		getFullTreeV2: build.query<StructureMetadataDtoRead[], GetFullTreeApiArg | undefined>({
			query: (filter) => {
				const params = new URLSearchParams()
				
				if (filter?.type) {
					filter.type.forEach((t) => params.append('type', t))
				}
				
				if (filter?.locked !== undefined) {
					params.append('locked', String(filter.locked))
				}

				if (filter?.maxLevel !== undefined) {
					params.append('maxLevel', String(filter.maxLevel))
				}
				
				const queryString = params.toString()
				return {
					url: `/v2/structure/tree${queryString ? `?${queryString}` : ''}`,
				}
			},
		}),
		getCustomAttributesComboV2: build.query<
			CustomAttributeComboDto[],
			{ structureType: CustomAttributeStructureTypeEnum }
		>({
			query: ({ structureType }) => ({
				url: `/v2/custom-attributes/combo/${structureType}`,
			}),
		}),
		getAllCustomAttributesV2: build.query<CustomAttributeDto[], void>({
			query: () => ({ url: `/v2/custom-attributes` }),
		}),
	}),
	overrideExisting: false,
})

export const {
	useGetFullTreeV2Query,
	useLazyGetFullTreeV2Query,
	useGetCustomAttributesComboV2Query,
	useGetAllCustomAttributesV2Query,
} = mddApiV2Enhanced

